import script from "./CaskVideoColCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CaskVideoColCard.vue?vue&type=script&setup=true&lang=js"

import "./CaskVideoColCard.vue?vue&type=style&index=0&id=7309eec4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7309eec4"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QImg});
